import Cookies from 'js-cookie';

//  Helper for cookies related operations
export const userCookie = 'user';
export const versionCookie = 'version'

// not putting date, so leaving the expires part empty will create a session cookie
export function bake_cookie(name, value, date=60){
    // domain null in order to use in localhost
    Cookies.set(name, value, {domain: null,expires: date});
    // let expirey = date instanceof Date ? '; expires='+date : null
    // var cookie = [name, '=', JSON.stringify(value), '; domain_.', window.location.host.toString(), '; path=/;',expirey].join('');
    // document.cookie = cookie;
}

// reads a cookie according to the given name
export function read_cookie(name) {
    return Cookies.getJSON(name);
    // var result = document.cookie.match(new RegExp(name + '=([^;]+)'));
    // result = result != null ? JSON.parse(result[1]) : [];
    // return result;
}

export function delete_cookie(name) {
    Cookies.remove(name);
    // document.cookie = [name, '=; expires=Thu, 01-Jan-1970 00:00:01 GMT; path=/; domain.', window.location.host.toString()].join('');
}


// WEBPACK FOOTER //
// ./src/helpers/cookieHelper.js